<template>
  <div>
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></SiruiSearch>

    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :loading="load"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnListDefault"
        rowKey="ids"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column type="index" width="50"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columnListDefault"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :formatter="item.formatter"
          :field="item.field"
          :title="item.title"
        >
          <template slot-scope="scope">
            <span v-if="item.field === 'result'">
              {{ scope.row[item.field] == 0 ? '成功' : '失败' }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  import tableMixins from '@/common/mixins/table.js';
  import moment from 'moment';
  export default {
    name: 'index',
    mixins: [tableMixins],
    data() {
      return {
        query: {
          userName: '',
        },
        columnListDefault: [
          {
            field: 'menu',
            title: '菜单',
            visible: true,
          },
          {
            field: 'content',
            title: '操作内容',
            visible: true,
          },
          {
            field: 'result',
            title: '操作结果',
            visible: true,
          },
          {
            field: 'message',
            title: '失败原因',
            visible: true,
          },
          {
            field: 'userName',
            title: '操作用户',
            visible: true,
          },
          {
            field: 'gmtCreate',
            title: '创建时间',
            visible: true,
          },
        ],
      };
    },
    computed: {
      searchColumns() {
        return [
          {
            prop: 'userName',
            name: '用户名',
            type: 'input',
            maxlength: 30,
            placeholder: '请输入用户名',
          },
          {
            prop: 'dateStart',
            name: '操作时间起',
            type: 'date',
          },
          {
            prop: 'dateEnd',
            name: '操作时间止',
            type: 'date',
          },
        ];
      },
    },
    methods: {
      async getData() {
        this.load = true;
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const params = { ...this.query, pageNum, pageSize };
        if (params.dateStart) {
          params.dateStart = moment(params.dateStart).startOf('day').format('YYYY-MM-DD HH:mm:ss');
        }
        if (params.dateEnd) {
          params.dateEnd = moment(params.dateEnd).endOf('day').format('YYYY-MM-DD HH:mm:ss');
        }
        await this.$axios.post('/maindata/interflowLog/queryInterflowLog', params).then((res) => {
          this.load = false;
          this.tableData = res.data.data.list;
          if (this.$refs.siruiTable) {
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          }
        });
      },
      handleQuery() {
        this.query.pageNum = 1;
        this.getList();
      },
      /** 重置按钮操作 */
      resetBtnClick() {
        //删除已经存在的字段
        this.query.userName = '';
        delete this.query.pageSize;
        delete this.query.pageNum;
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.tableData = [];
        this.$refs.siruiTable.reloadTable(this.tableData);
        this.getData();
      },
    },
    mounted() {
      this.getData();
    },
  };
</script>

<style scoped lang="scss">
  .search {
    margin-bottom: 10px;
    padding: 0 30px;
    background-color: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .form-box {
      display: flex;
      .el-form-item {
        width: 320px;
        margin-left: 20px;
        margin-top: 18px;
        ::v-deep .el-form-item__label {
          width: 80px;
        }
        ::v-deepep .el-form-item__content {
          margin-left: 80px;
        }
        ::v-deepep .el-select {
          width: 100%;
        }
        ::v-deepep .el-date-editor.el-input,
        .el-date-editor.el-input__inner {
          width: 100%;
        }
      }
      .item {
        display: flex;
        flex-wrap: wrap;
      }
    }

    .btn {
      width: 90px;
      height: 30px;
      display: inline-block;
      line-height: 30px;
      text-align: center;
      border-radius: 3px;
      img {
        vertical-align: middle;
        padding-right: 10px;
      }
    }

    .btn-search {
      background-color: #409eff;
      color: #ffffff;
    }
    .btn-reset {
      background-color: #ffffff;
      color: #409eff;
      border: 1px solid #e4e6eb;
    }
  }
</style>
